import { ForcePasswordUpdateForm } from "./ForcePasswordUpdateForm";

export const ForcePasswordUpdatePage = () => {
  return <ForcePasswordUpdateForm />;
};
